// extracted by mini-css-extract-plugin
export default {"mCard":"RD-z","image":"SD-z","imageNoBackground":"TD-z","imageHasCategory":"UD-z","fullWidth":"VD-z"};